import styled from 'styled-components';

export const CategorySection = styled.section`
  &:not(:last-child) {
    margin-bottom: 24px;
  }
`;

export const CategoryTitle = styled.h4`
  margin: 0 0 12px;
  font-size: 14px;
  font-weight: 500;
  color: #334423;
`;

export const SignGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
`;

export const SignItem = styled.button<{ $selected?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 8px 4px;
  border: 2px solid
    ${({ $selected, theme }) =>
      $selected ? theme.antd?.colorPrimary || '#1677ff' : '#f0f0f0'};
  border-radius: 8px;
  background: ${({ $selected }) => ($selected ? '#f6ffed' : '#fff')};
  cursor: pointer;
  transition:
    border-color 0.2s,
    background 0.2s;

  &:hover {
    border-color: ${({ theme }) => theme.antd?.colorPrimary || '#1677ff'};
  }

  img {
    width: 48px;
    height: 48px;
    object-fit: contain;
  }
`;

export const SignCode = styled.span`
  font-size: 11px;
  color: #666;
  line-height: 1;
`;

export const SignTitle = styled.div`
  font-size: 11px;
  color: #666;
  line-height: 1.3;
  text-align: center;
  word-break: break-word;

  strong {
    font-weight: 700;
  }
`;

export const ModalBody = styled.div`
  max-height: 60vh;
  overflow-y: auto;
  padding: 8px 0;
`;
